// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Uw9uS","actions":"styles_actions__VNkEP","link":"styles_link__N8ZQ-"};